<template>
  <div class="policy-page">
    <WeCircularNavbar @go-home="$emit('go-home')" @go-countries="$emit('go-countries')" />

    <main class="policy-page__container">
      <button class="back-button" type="button" @click="$router.back()">
        ← Back
      </button>

      <section class="policy-hero">
        <div class="policy-hero__content">
          <h1 class="policy-title">European Policies and Strategies</h1>

          <p class="policy-intro">
            Discover the key European policies and strategies shaping the future of Circular Economy, Digitalization,
            Women Entrepreneurs, and Smart Specialisation Strategies (S3). Explore each topic below and dive deeper into
            the most relevant documents.
          </p>
        </div>
      </section>

      <section class="cards-section">
        <div class="cards-grid">
          <router-link
            to="/we-circular/policy-landscape/european-policies/circular-economy"
            class="info-card info-card--link"
          >
            <div class="card-header"></div>

            <div class="card-body">
              <div class="card-icon">
                <img :src="circularIcon" alt="Circular Economy" />
              </div>

              <h3 class="card-title">Circular Economy</h3>

              <p class="card-text">
                Explore how European circular economy policies drive sustainable growth, resource efficiency and
                innovative business models.
              </p>
            </div>
          </router-link>

          <router-link
            to="/we-circular/policy-landscape/european-policies/digitalization"
            class="info-card info-card--link"
          >
            <div class="card-header"></div>

            <div class="card-body">
              <div class="card-icon">
                <img :src="monitorIcon" alt="Digitalization" />
              </div>

              <h3 class="card-title">Digitalization</h3>

              <p class="card-text">
                Discover key EU strategies accelerating digital transformation, innovation and competitiveness across
                sectors.
              </p>
            </div>
          </router-link>

          <router-link
            to="/we-circular/policy-landscape/european-policies/women-entrepreneurs"
            class="info-card info-card--link"
          >
            <div class="card-header"></div>

            <div class="card-body">
              <div class="card-icon">
                <img :src="bagIcon" alt="Women Entrepreneurs" />
              </div>

              <h3 class="card-title">Women Entrepreneurs</h3>

              <p class="card-text">
                Learn how European policies empower women entrepreneurs and support inclusive, sustainable economic
                development.
              </p>
            </div>
          </router-link>

          <router-link
            to="/we-circular/policy-landscape/european-policies/smart-specialisation-strategies"
            class="info-card info-card--link"
          >
            <div class="card-header"></div>

            <div class="card-body">
              <div class="card-icon">
                <img :src="graphIcon" alt="Smart Specialisation Strategies" />
              </div>

              <h3 class="card-title">Smart Specialisation Strategies (S3)</h3>

              <p class="card-text">
                Understand how Smart Specialisation Strategies help regions focus on their strengths to foster
                innovation and smart growth.
              </p>
            </div>
          </router-link>
        </div>
      </section>
    </main>

    <WeCircularFooter />
  </div>
</template>

<script>
import WeCircularNavbar from './WeCircularNavbar.vue'
import WeCircularFooter from './WeCircularFooter.vue'

import circularIcon from '../../assets/img/we-circular/Stats/Circular.svg'
import monitorIcon from '../../assets/img/we-circular/Stats/Monitor.svg'
import bagIcon from '../../assets/img/we-circular/Stats/Bag.svg'
import graphIcon from '../../assets/img/we-circular/Stats/Graph.svg'

export default {
  name: 'EuropeanPoliciesAndStrategies',
  components: {
    WeCircularNavbar,
    WeCircularFooter
  },
  emits: ['go-home', 'go-countries'],
  data() {
    return {
      circularIcon,
      monitorIcon,
      bagIcon,
      graphIcon
    }
  }
}
</script>

<style scoped>
.info-card--link {
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-card--link:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(16, 36, 94, 0.12);
}

.policy-page {
  min-height: 100vh;
  background: #f3f3f3;
  padding: 22px 0 64px;
}

.policy-page__container {
  width: 100%;
  max-width: 80%;
  margin: 0 auto;
  padding: 0 38px;
  box-sizing: border-box;
  margin-bottom: 5vw;
  text-align: left;
}

.back-button {
  display: flex;
  align-items: center;
  height: 30px;
  min-width: 66px;
  padding: 0 12px;
  margin-bottom: 22px;
  border: 1px solid #003399;
  border-radius: 8px;
  background: transparent;
  color: #003399;
  font-size: 13px;
  cursor: pointer;
}

.policy-hero {
  margin-bottom: 26px;
}

.policy-hero__content {
  max-width: 580px;
}

.policy-title {
  margin: 0;
  color: #003399;
  font-size: 54px;
  line-height: 1.02;
  font-weight: 600;
  letter-spacing: -0.03em;
  text-align: left;
}

.policy-intro {
  max-width: 420px;
  margin: 16px 0 26px;
  color: #0e6eb6;
  font-size: 14px;
  line-height: 1.55;
  text-align: left;
}

.cards-section {
  margin-top: 20px;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;
}

.info-card {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid rgba(16, 36, 94, 0.08);
  display: flex;
  flex-direction: column;
}

.card-header {
  height: 70px;
  background: #004f4f;
  background-image: url('../../assets/img/we-circular/9-16@4x.png');
  background-size: cover;
  background-position: center;
}

.card-body {
  padding: 22px 18px 24px;
  text-align: center;
}

.card-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #0e6eb6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -40px auto 14px;
}

.card-icon img {
  width: 22px;
  height: 22px;
  display: block;
}

.card-title {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 600;
  color: #003399;
  line-height: 1.25;
}

.card-text {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #5f6f86;
}

@media (max-width: 1100px) {
  .policy-page__container {
    max-width: 92%;
    padding: 0 20px;
  }

  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }

  .policy-title {
    font-size: 28px;
  }
}
</style>
